import { render, staticRenderFns } from "./EditPS.vue?vue&type=template&id=48747764&"
import script from "./EditPS.vue?vue&type=script&lang=js&"
export * from "./EditPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports